import React from "react";
import { Field } from "formik";
import { useTheme } from "../Providers/ThemeContext";

const RadioButton = ({ name, value, label }) => {
  const { colors } = useTheme();

  return (
    <Field name={name}>
      {({ field, form }) => (
        <label className="inline-block mr-2 mb-2">
          <input
            type="radio"
            {...field}
            value={value}
            checked={field.value === value}
            className="hidden"
          />
          <span
            className={`
              inline-block px-4 py-2 text-sm font-medium cursor-pointer
              rounded-md transition-all duration-200 ease-in-out
              ${
                field.value === value
                  ? "text-white"
                  : `text-${colors.text} hover:bg-opacity-10`
              }
            `}
            style={{
              backgroundColor:
                field.value === value ? colors.primary : "transparent",
              borderColor:
                field.value === value ? colors.primary : colors.border,
              borderWidth: "2px",
              borderStyle: "solid",
            }}
          >
            {label}
          </span>
        </label>
      )}
    </Field>
  );
};

export default RadioButton;
